<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>打印标签</span>
    </template>
    <template #content>
<!--      <p>{{ form | json }}</p>-->
      <el-form
          ref="form"
          :model="form"
          :inline="true">
        <!-- <el-form-item
            label="统一打印数量"
            prop="commonNum"
            :rules="[ $gjReRule(RE.pt, '请输入正整数') ]">
          <gj-input
              v-model.number="form.commonNum"
              @input="inputCommonNum($event)"
              width="250px"
          ></gj-input>
        </el-form-item> -->
        <el-form-item
            v-if="false"
            label="纸张类型"
            prop="paperType">
          <gj-select
              v-model="form.paperType"
              :options="paperLabelOption"
              :clearable="false"
              width="350px"
          ></gj-select>
        </el-form-item>

        <el-form-item>
            <span class="add-product-btn gj-mb-10">
                <gj-button @click="addProduct" type="primary">添加产品</gj-button>
            </span>
            <el-form-item
              label="统一打印数量"
              prop="commonNum"
              :rules="[ $gjReRule(RE.pt, '请输入正整数') ]">
            <gj-input
                v-model.number="form.commonNum"
                @input="inputCommonNum($event)"
                width="250px"
            ></gj-input>
          </el-form-item>
        </el-form-item>


        
        <gj-table
            :index="false"
            name="printProductLabel"
            :data="form.items"
            :columns="columns"
            :offset-height="75"
            :show-pagination="false">
          <template v-slot:printNum="{ index }">
            <el-form-item
                :prop="`items.${index}.printNum`"
                :rules="[
                  { required: true, message: '请输入打印数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入正整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].printNum"
                  width="150px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{ index }">
            <gj-button
                type="text"
                :disabled="form.items.length <= 1"
                @click="deleteItem(index)">
              删除
            </gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, formValidatorMixin, modalMixIn} from "../../../../../../minxins";
  import {paperLabelOption} from "../../../../../../utils/options";
  import AppAddProductModal from "./add-product-modal";
  import {isMeaningful, isMeaningless, unique} from "../../../../../../utils/common";
  import {getProductLabels} from "../../../../../../api/product";

  export default {
    name: "app-print-product-label",
    mixins: [modalMixIn, formValidatorMixin, formDeleteItemMixin, formRuleMixin],
    props: {
      products: {
        type: Array
      }
    },
    created() {
      this.products.forEach(product => {
        this.form.items.push({
          ...product,
          printNum: null
        });
      });
    },
    data() {
      return {
        paperLabelOption: paperLabelOption,
        form: {
          commonNum: null,
          paperType: 1,
          items: []
        },
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px'},
          {id: 'sku', header: 'SKU', field: 'sku', minWidth: '100px'},
          {id: 'name', header: '产品名称', field: 'name', minWidth: '150px'},
          {id: 'printNum', header: '打印数量', field: 'slot:printNum', minWidth: '100px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '80px', notCustomColumn: true},
        ],
      }
    },
    methods: {
      inputCommonNum(num) {
        if (this.formValidateField('commonNum') && isMeaningful(num)) {
          this.form.items.forEach(e => e.printNum = num);
        }
      },
      addProduct() {
        this.$gjCreate(AppAddProductModal, {
          props: {
            hideSkuList: this.form.items.map(item => item.sku),
          },
          on: {
            select: (products) => {
              if (this.form.commonNum) {
                products.forEach(item => {
                  item.printNum = this.form.commonNum;
                });
              }
              this.form.items = unique([].concat(products || []).concat(this.form.items), 'sku');
            }
          }
        });
      },
      confirm() {
        if (isMeaningless(this.form.items) || this.form.items.length === 0) {
          this.$gjMessage.error('请选择要打印标签的产品');
        }
        if (this.formValidate()) {
          this.confirmLoading = true;
          getProductLabels(this.form.items.map(item => ({
            name: item.name,
            sku: item.sku,
            quantity: item.printNum
          })))
            .then((url) => {
              window.open(url);
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-product-btn {
    margin-right: 20px;
  }
  /deep/ .el-form-item__label{
    line-height: 31px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
/deep/.vxe-table--body {
  .vxe-body--row {
    .vxe-body--column {
      height: 58px !important;
    }
  }
}
</style>
